'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _addToCart = require('../components/add-to-cart');

var _addToCart2 = _interopRequireDefault(_addToCart);

var _giftListUpdater = require('../../gift-list-updater');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("App", "Common");

function mapStateToProps(state, ownProps) {
    var price = ownProps.price,
        productId = ownProps.productId,
        amount = ownProps.amount,
        _ownProps$amountAvail = ownProps.amountAvailable,
        amountAvailable = _ownProps$amountAvail === undefined ? 0 : _ownProps$amountAvail,
        _ownProps$totalAmount = ownProps.totalAmountAvailable,
        totalAmountAvailable = _ownProps$totalAmount === undefined ? 0 : _ownProps$totalAmount,
        giftId = ownProps.giftId,
        name = ownProps.name,
        authors = ownProps.authors;

    var item = state.cart.itemAmounts.find(function (i) {
        return i.productId === productId;
    });
    var props = {
        price: price,
        productId: productId,
        amount: item && item.amount || 0,
        amountAvailable: amountAvailable,
        totalAmountAvailable: totalAmountAvailable,
        origAmount: amount,
        processing: false,
        giftId: giftId,
        name: name,
        authors: authors
    };
    props.processing = !!state.cart.updating[(0, _linksoftAlbatros.getCartChangeKey)(props)];
    props.amount = (0, _linksoftAlbatros.getCartAmountFor)(props, state);
    return props;
}

var mapDispatchToProps = {
    changeAmount: _actions2.default.changeAmount,
    submitChanges: _actions2.default.submitChanges
};

var AddToCartContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
    (0, _inherits3.default)(AddToCartContainer, _React$Component);

    function AddToCartContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddToCartContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddToCartContainer.__proto__ || (0, _getPrototypeOf2.default)(AddToCartContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
            _this.props.submitChanges({
                productId: _this.props.productId,
                amount: _this.props.amount + 1,
                customerId: _this.props.customerId,
                giftId: _this.props.giftId,
                takeCompact: true,
                price: _this.props.price,
                id: _this.props.productId,
                productName: _this.props.name || _this.props.productName,
                authors: _this.props.authors,
                resultPrice: _this.props.resultPrice,
                brandName: _this.props.brandName,
                categoryName: _this.props.categoryName,
                ean: _this.props.ean
            }, true);
        }, _this.handleProcessing = function () {
            // this disable scrolling
            // need it for perfect starting position of "flying pseudo cart"
            (0, _jquery2.default)('body').on('scroll touchmove mousewheel', function (e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            });

            // make scroll enable again
            setTimeout(function () {
                (0, _jquery2.default)('body').off('scroll touchmove mousewheel');
            }, 1000);
        }, _this.handleProcessingComplete = function (e) {}, _this.handleSubmitComplete = function (btn) {
            if (_this.props.giftId > 0) {
                (0, _giftListUpdater.updateGiftCatalog)();
            }

            // facebook pixel integration - report item added to cart
            if (typeof fbq !== 'undefined') {
                var _this$props = _this.props,
                    productId = _this$props.productId,
                    price = _this$props.price;


                fbq('track', 'AddToCart', {
                    content_ids: [productId + ''],
                    value: price,
                    currency: Resx.Common.CurrencyCode
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AddToCartContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_addToCart2.default, (0, _extends3.default)({ onSubmit: this.handleSubmit,
                onProcessing: this.handleProcessing,
                onProcessingComplete: this.handleProcessingComplete,
                onSubmitComplete: this.handleSubmitComplete
            }, this.props));
        }
    }]);
    return AddToCartContainer;
}(_react2.default.Component), _class2.propTypes = {
    price: _propTypes2.default.number,
    amount: _propTypes2.default.number,
    productId: _propTypes2.default.number,
    customerId: _propTypes2.default.number,
    processing: _propTypes2.default.bool.isRequired,
    amountAvailable: _propTypes2.default.number,
    totalAmountAvailable: _propTypes2.default.number,
    submitChanges: _propTypes2.default.func.isRequired,
    giftId: _propTypes2.default.number,
    productName: _propTypes2.default.string,
    authors: _propTypes2.default.array,
    resultPrice: _propTypes2.default.object,
    brandName: _propTypes2.default.string,
    categoryName: _propTypes2.default.string,
    ean: _propTypes2.default.string
}, _temp2)) || _class);
exports.default = AddToCartContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/add-to-cart.js
// module id = 1038
// module chunks = 0